import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ConfirmForgotPasswordResponse,
  ConfirmForgotPasswordInput,
  confirmForgotPasswordResponseSchema,
  ErrorResponse,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPIConfirmForgotPassword = (
  options?: UseMutationOptions<
    ConfirmForgotPasswordResponse,
    ErrorResponse,
    ConfirmForgotPasswordInput
  >
) =>
  useMutation({
    mutationFn: (values) =>
      post(
        API_ENDPOINTS.CONFIRM_FORGOT_PASSWORD,
        values,
        confirmForgotPasswordResponseSchema
      ),
    ...options,
  })
